import React from 'react'
import GetAppIcon from '@material-ui/icons/GetApp'
import styled from '@emotion/styled'

type Props = {
  onClick: () => void
}

const StyledDownloadButton = styled(GetAppIcon)`
  font-size: 30px !important;

  &.MuiSvgIcon-root {
    fill: white;
  }
`

export const IconWrapper = styled.div`
  width: 38px;
  height: 38px;
  background-color: #289c91;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #f0535d;
    cursor: pointer;
  }
`

const DownloadIconButton = (props: Props) => (
  <IconWrapper {...props} onClick={props.onClick}>
    <StyledDownloadButton />
  </IconWrapper>
)

export default DownloadIconButton
